import React from 'react';
import { Stack } from '@mui/material';

import { Typography } from './Typography';

import { ErrorOutlinedIcon } from '../icons';

export interface HelpTipProps {
  children?: React.ReactNode;
  icon?: React.ReactNode;
  title: string;
}

export const HelpTip = (props: HelpTipProps) => {
  const {
    title,
    children,
    icon = <ErrorOutlinedIcon fontSize='small' sx={{ color: 'grey.400' }} />,
  } = props;

  return (
    <Stack bgcolor='grey.100' p={2} borderRadius={1} spacing={1}>
      <Stack direction='row' spacing={1} alignItems='center'>
        {icon}
        <Typography variant='subtitle2' color='textSecondary'>
          {title}
        </Typography>
      </Stack>
      {children}
    </Stack>
  );
};
